import { useEffect, useSyncExternalStore } from 'react';
import { refreshIntegrity, startIntegrity } from '../api/integrity';
import { integrityStatus, subscribeIntegrity } from '../api/integrityState';
import { playStoreUrl } from './useAppUpdate';

/**
 * W24 app integrity state for the gate: starts the check once, exposes the status and the two
 * actions of the "install from the Play Store" sheet.
 */
export function useIntegrity() {
  useEffect(() => startIntegrity(), []);
  const status = useSyncExternalStore(subscribeIntegrity, integrityStatus, integrityStatus);
  return {
    blocked: status === 'failed',
    status,
    openStore: () => window.open(playStoreUrl('customer'), '_blank', 'noopener'),
    retry: () => void refreshIntegrity(),
  };
}
